import { createRootRouteWithContext } from '@tanstack/react-router';
import { RootLayout } from '../app/components/RootLayout';
import type { Authenticator } from '../features/auth/authenticator';
import { requireSignIn } from '../features/auth/route-guard';

interface RouterContext {
  readonly authenticator: Authenticator;
}

// Every route needs a signed-in user unless it is marked `public` (D-057).
export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
  beforeLoad: ({ context, location, matches }) =>
    requireSignIn({ authenticator: context.authenticator, location, matches }),
});
